import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ILoginForm } from '../../forms/login-form/login-form.component';
import { AuthService } from '../../services/auth.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { ModalController } from '@ionic/angular';
import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { ReservationComponent } from 'src/app/reservation-page/pages/reservation-page/reservation-page.component';
import { OrderListPageComponent } from 'src/app/account/pages/order-list-page/order-list-page.component';
import { OfferPageComponent } from 'src/app/account/pages/offer-page/offer-page.component';
import { LocationsPageComponent } from 'src/app/pages/locations-page/locations-page.component';
import { PayRewardPageComponent } from 'src/app/account/pages/pay-reward-page/pay-reward-page.component';
import { ProfilePageComponent } from 'src/app/account/pages/profile-page/profile-page.component';
import { SupportHomePageComponent } from 'src/app/support/pages/support-home-page/support-home-page.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'auth-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  @Output() onForgotPasswordClicked = new EventEmitter<void>();
  @Output() onLogin = new EventEmitter<void>();
  @Input() selfManage: boolean = false;
  @Input() fromDesktopCheckout: boolean = false;

  logo!: SafeUrl;

  constructor(
    private loader: LoaderService, 
    private router: Router, 
    private authService: AuthService, 
    public setting: SettingService, 
    private analytics: AnalyticsService,
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {}

  async onFormSubmited(form: ILoginForm) {
    
    if(this.setting.configuration?.logoShortName) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    } else if(this.setting.configuration?.logoUrl) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);
    } else {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);


    const loader = await this.loader.create();
    this.authService.login({
      Email: form.email,
      Password: form.password
    })
    .pipe(finalize(async () => {
      await loader.dismiss();
    }))
    .subscribe(async () => {
      this.onLogin.emit();

      if (this.selfManage || this.fromDesktopCheckout) {
        return;
      }

      this.analytics.conversionUpdate("signIn");



      var CurrentUrl;
      CurrentUrl = localStorage.getItem('Stateurl');
      if(CurrentUrl.includes('popup-')) {

        if(CurrentUrl.includes('store')) {
          const modal = await this.modalCtrl.create({
            component: StoreListModalComponent,
            cssClass: 'store-popup-model',
            componentProps: {
              isTableOrder: false,
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('reservation')) {
          const modal = await this.modalCtrl.create({
            component: ReservationComponent,
            cssClass: 'reservation-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();

        } else if(CurrentUrl.includes('orderlist')) {
          const modal = await this.modalCtrl.create({
            component: OrderListPageComponent,
            cssClass: 'myorders-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('offers')) {
          const modal = await this.modalCtrl.create({
            component: OfferPageComponent,
            cssClass: 'offers-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('locations')) {
          const modal = await this.modalCtrl.create({
            component: LocationsPageComponent,
            cssClass: 'location-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('rewards')) {
          const modal = await this.modalCtrl.create({
            component: PayRewardPageComponent,
            cssClass: 'reward-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('profile')) {
          const modal = await this.modalCtrl.create({
            component: ProfilePageComponent,
            cssClass: 'profile-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        } else if(CurrentUrl.includes('contactus')) {
          const modal = await this.modalCtrl.create({
            component: SupportHomePageComponent,
            cssClass: 'support-popup-model',
            componentProps: {
              disableHeader: true
            }
          });
        
          modal.onWillDismiss()
            .then((result) => {
              
          });
        
          await modal.present();
        }


        
      } else {
        this.router.navigateByUrl(CurrentUrl);
      }
      

    }, (error) => {
      this.authService.showLoginError(error);
    });
  }

  onForgotPasswordClickedEvent() {
    this.onForgotPasswordClicked.emit();
  }
}
